import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import EventLogs from "../components/EventLogs";

export default function EventLogsPage() {
  return (
    <Box sx={{ padding: "8px 0" }}>
      <Box mb={2}>
        <Typography variant="h6">ประวัติการทำรายการ</Typography>
      </Box>
      <EventLogs />
    </Box>
  );
}
